<div *ngIf="message"
    [ngClass]="{ 'alert': message, 
                'alert-info': message.type === 'info', 
                'alert-warning': message.type === 'warning', 
                'alert-primary': message.type === 'primary', 
                'alert-success': message.type === 'success', 
                'alert-danger': message.type === 'error' }"
    [innerHtml]="message.text">
</div>